import { faqItems } from '@/mocks/home';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[960px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              常见问答
            </h2>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
              >
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}